import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import './style.css';
import NavbarRight from '../navbar-right/navbar-right';
import { ArrowLeft, Menu, Users } from 'react-feather';
import ButtonBack from '../../global-components/src/components/buttons/back';
import { getAppVersion, isIOSWebView, removeToNativeiOS } from '../../utils/platform';
import { AddAccount, useAuth, useTheme } from '../../global-components/src';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Clapperboard } from 'lucide-react';
import { Icon } from '../../global-components/src/components/icon';
import { useFeed } from '../../contexts/FeedContext';

const NavbarTop = ({ children, title, showMenuIcon=true, hiddenInScroll=true}: { children?: React.ReactNode, title?: string, showMenuIcon?: boolean, hiddenInScroll?: boolean }) => {
    const [isAtTop, setIsAtTop] = useState(false);
    const { isDarkMode, isNewPacoca } = useTheme();
    const { user } = useAuth();
    const { setPage } = useFeed();
    const location = useLocation();
    const navigate = useNavigate();
    const path = location.pathname;

    useEffect(() => {
        let lastScrollY = window.scrollY;
    
        const handleScroll = () => {
            const menu = document.querySelector('.small-menu-top') as HTMLElement;
            if (!menu || !hiddenInScroll || window.location.pathname.includes("/@")) return;
    
            if (window.innerWidth <= 850) {
                if (window.scrollY > lastScrollY) {
                    menu.classList.add("hidden-top-menu");
                } else {
                    menu.classList.remove("hidden-top-menu");
                }
            }
            lastScrollY = window.scrollY;
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    useEffect(() => {
        setIsAtTop(true);
        const handleScroll = () => {
            setIsAtTop(window.scrollY < 40); // considera "no topo" se scroll for menor que 10px
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const shouldUseBackgroundFeed = useMemo(() =>
      window.innerWidth <= 850 && (!isNewPacoca && path === "/") && isAtTop, 
    [isAtTop, window.innerWidth, path]);

    const menuTransparent = useMemo(() =>
      isNewPacoca && path.includes("/@") && isAtTop, 
    [isAtTop, window.innerWidth, path]);

    useEffect(() => {
        if(path.includes("@") && !path.includes("chat")) return;
        if (!window.ReactNativeWebView || typeof window.ReactNativeWebView.postMessage !== 'function') return;

        if(path == "/login" || path == "/cadastro"){
            window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: "transparent" }));
            return;
        }

        window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: (!isNewPacoca && path === "/") && isAtTop ? (isDarkMode ? "#181818" : "#F4F2EE") : (isDarkMode ? "#000" : "#fff") }));
    }, [isAtTop, window.ReactNativeWebView, window.ReactNativeWebView?.postMessage, window.innerWidth, path, isDarkMode]);

    useEffect(() => {
        const modalBody = document.getElementById("root") as HTMLElement | null;
        if (!modalBody || !hiddenInScroll || window.location.pathname.includes("/@")) return;

        if (modalBody) {
            let lastScrollY = modalBody.scrollTop; // Correção aqui
            let last = modalBody.scrollTop;

            const handleScroll = () => {                
                const menu = document.querySelector('.small-menu-top') as HTMLElement;
                if (!menu) return;
                
                if (window.innerWidth <= 850) {
                    const current = modalBody.scrollTop;
                    const TOP_THRESHOLD = isIOSWebView() ? 200 : 0
                    const isNearTop = current < TOP_THRESHOLD;
                    
                    if (!isNearTop && current > last) {
                        menu.classList.add("hidden-top-menu");
                    } else {
                        menu.classList.remove("hidden-top-menu");
                    }
                }
                lastScrollY = modalBody.scrollTop; // Correção aqui
            };
    
            modalBody.addEventListener('scroll', handleScroll); // Correção aqui
    
            return () => {
                modalBody.removeEventListener('scroll', handleScroll); // Correção aqui
            };
        }
    }, []);

    const resetHome = () => {
        if(path != "/"){
            navigate("/");
            return;
        }
        setPage(-1);
    }   
    

    return (
        <>
            <div id='small-menu-top' className={`user-select-none small-menu-top align-items-center justify-content-between ${menuTransparent ? "small-menu-top-transparent" : ""}`} style={{ background: shouldUseBackgroundFeed ? (isDarkMode ? "oklch(0.21 0 0)" : "var(--background-feed)") : "", paddingTop: shouldUseBackgroundFeed ? 15 : ""  }}>
                <div className='d-flex justify-content-start align-items-center' style={{ width: "calc(100% - 20px)" }}>
                   {path != "/" ? (
                        <div className="col icon-back-menu-top" style={{ width: 30 }}>
                            {path === "/chats" ? (
                                <span onClick={() => navigate("/")} className="filter-invert-color btn-back btn-dark cursor-pointer" id="btn-close-modal">
                                    <ArrowLeft className="icon-back"/>
                                </span>
                            ) : (
                                <ButtonBack/>
                            )}
                        </div>
                   ): (
                        <>
                            {!removeToNativeiOS(user?.id) && (
                                <button className="none-pc icon-small-menu-top" onClick={() => navigate("/flow")} aria-label="Ir para o Flow" style={{ border: 0, borderRadius: "5px", background: "transparent", marginTop: 3 }} type="button">
                                    <Clapperboard
                                        className={`icon-menu-dark ${path.startsWith('/flow') ? 'active' : ''}`}
                                        opacity={.6}
                                        size={27}
                                    />
                                </button>
                            )}
                            <button className="none-pc icon-small-menu-top" onClick={() => navigate("/comunidades")} aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "transparent", marginTop: 1 }} type="button">
                                <Icon size={24} style={{ margin: 0 }} invertColor={!isDarkMode} name="diversity_1">
                                    <Users opacity={.6} size={23}/>
                                </Icon>
                            </button>
                        </>
                    )}

                    
                    <h5 className={`text-no-wrap modal-title`} id="modal-curtida" style={{ width: "calc(100%)" }}>{title}</h5>
                </div>

                {!title ? (
                    <div className="col d-flex justify-content-center" style={{ position: "absolute", left: "50%", transform: "translateX(-50%)"}}>
                        <img onClick={resetHome} src="/img/pacoca-sem-braco.png" className="cursor-pointer" alt="Logo do Paçoca" height="30"/>
                    </div>

                ) : null}

                <div className='d-flex' style={{ gap: 10 }}>
                    {children}

                    {showMenuIcon ? (
                        <div className="col cursor-pointer icon-small-menu-top" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions">
                            <Menu data-feather="menu" opacity={.6}/>
                        </div>
                    ): null}
                </div>
            </div>
            <NavbarRight/>
        </>
    );
};

export default NavbarTop;
